/**
 * The class is responsible for dealing with storing all the operation on favorite images.
 * The favoriteImageIds are reconstructed and new set of images are added as favorites in three flows.
 * 1.In cluster view, when the clusters are loaded, we are getting favorite response as part of it as well.
 * 2.In SAV, when the album images are loaded, we are getting favorites response as well.
 * 3.In my shared albums view, when we are first making owned albums call for the album to get favorites images response.
 */
export class AGFavoritesManager {
  static favoriteImageIds: string[] = [];
  /**
   * Setter method to update the favorite images ids array.
   * @param favoriteImageIds 
   */
  static setFavoriteImages(favoriteImageIds: string[]){
    this.favoriteImageIds = favoriteImageIds;
  }
  /**
   * Getter method to get the favorites images ids string.
   */
  static getFavoriteImages(): string[]{
    return this.favoriteImageIds;
  }
  /**
   * Method to add an image to the favorite list.
   * @param favImageId 
   */
  static add(favImageId : string){
    this.favoriteImageIds.push(favImageId);
  }
  /**
   * Method to delete an image from the favorites list.
   * @param favImageId 
   */
  static delete(favImageId : string){
    let imageIndex = this.favoriteImageIds.indexOf(favImageId);    
    if(imageIndex !== -1)//If image is removed as favorite.
      this.favoriteImageIds.splice(imageIndex, 1);    
  }
  /**
   * Method to check if an image is in the favorites list or not.
   */
  static isFavorite(imageId: string) : boolean{
    let imageIndex = this.favoriteImageIds.indexOf(imageId);    
    if(imageIndex != -1)
      return true;
    else
      return false;
  }
}